import { AttachedContent } from '../../trait/attachedcontent/AttachedContent';
import { ALPHABETH } from '../../../utils/helper/helper_string';
export class AttachedTable extends AttachedContent {
    type = 'table';
    get numberOfRows() {
        return this.core.valueOf.rows;
    }
    get numberOfColumns() {
        return this.core.valueOf.columns;
    }
    cellAspectNameToCellNumber(aspectName /* e.g. cell_B7 */) {
        const columnLetter = aspectName.charAt(5);
        const columnNumber = ALPHABETH.indexOf(columnLetter) + 1;
        const rowNumber = parseInt(aspectName.substring(6));
        return this.numberOfColumns * (rowNumber - 1) + columnNumber;
    }
}
